import Intercept from "@observer/Intercept.js";
import API from "@api/index.js";
import { $util, $event_publisher } from "@util/util.js";
import Constant from "@constant/index.js";
import Alert from "@util/alert_wap.js";
import useDiscountDetailsStore from "@shared/store/useDiscountDetailsStore";
import { Bridge } from "@shared/bridge";

export default class PriceWapView{
    constructor(model){
        this._el = null;
        this._model = model;

        this._model._view = this;

        this._totalPrefixEl = $('span.ptotalprefix');
        this._totalSuffixEl = $('span.ptotalsuffix');
        this._discountEl = $('span.pdiscount');
        this._checkEl = $("i[tag='isCheckedAll']");
        this._totalCheckedCount = $('span.ptotalcount');
        this._completeBoxEl = $('div.complete_box');
        this._editBoxEl = $('div.edit_box');
        this._completeButtonEl = $('span.complete');
        this._editButtonEl = $('span.edit');

        this._discountDetailsEl = $('#discountDetailsBox');
        this._checkoutBtnText = $('#settlementCheckoutText');
    }

    

    interceptList(){
        //_totalPrefix
        new Intercept().init(this._totalPrefixEl, this._model, "_totalPrefix");
        //_totalSuffix
        new Intercept().init(this._totalSuffixEl, this._model, "_totalSuffix");
        //_discount
        new Intercept().init(this._discountEl, this._model, "_discount");
        //checked
        new Intercept().init(this._checkEl, this._model, "checkedAll", 'ck');
        //total chekced items
        new Intercept().init(this._totalCheckedCount, this._model, "_totalCheckedCount");
        if(this._editBoxEl){
            _engine._wapIsEditIntercept.addObserver(this._editBoxEl,'cls',"isedit","is-not-edit");
        }
        if(this._completeButtonEl){
            _engine._wapIsEditIntercept.addObserver(this._completeButtonEl,'cls',"isedit","is-not-edit");
        }
        if(this._editButtonEl){
            _engine._wapIsEditIntercept.addObserver(this._editButtonEl,'cls',"is-not-edit","isedit");
        }
        if(this._completeBoxEl){
            _engine._wapIsEditIntercept.addObserver(this._completeBoxEl,'cls',"is-not-edit","isedit");
        }
    }

    checkLogin(){
        // if (window.location.href.indexOf('localhost') != -1) {
        //     return;
        // }
        if(!passport.isLogin()){
            $("div.unlogin_wrapper").css("display","flex");
            // $("div.header_right span.edit").css("display","none");
            this._editButtonEl.addClass("is-not-edit").removeClass("isedit");
            $("#cart_wap_wrapper .main").addClass("unlogin_top");
            $(".cart_settlement").hide();
        }else{
            $("div.unlogin_wrapper").css("display","none");
            $("#cart_wap_wrapper .main").removeClass("unlogin_top")
            // 非编辑状态时判断是否展示编辑按钮
            if(!_engine._editStatus){
                if(this._model._parent._group.length > 0 ){
                    // $("div.header_right span.edit").css("display","inline-block");
                    this._editButtonEl.addClass("isedit").removeClass("is-not-edit");  
                    $(".cart_settlement").show();                   
                }else{
                    // $("div.header_right span.edit").css("display","none");                    
                    this._editButtonEl.addClass("is-not-edit").removeClass("isedit");
                    $(".cart_settlement").hide();
                }
            }
        }
    }

    checkCartEmpty(){
        if(this._model._totalCount <= 0){
            $("div.cart_empty").show(); 
            this._model._isChecked = false;
                    
        }else{
            $("div.cart_empty").hide();
        }
    }
    
    
    render(){
        let invalidItems = $util.getInvalidItems(this._model._parent._group);
        if(invalidItems.length > 0){
            $("#failureGoodsCount").text(invalidItems.length);
            $(".cart_wrap_invalid").show();
        }else{
            $("#failureGoodsCount").text("0");
            $(".cart_wrap_invalid").hide();
        }

        this._totalPrefixEl.text(this._model._totalPrefix);
        this._totalSuffixEl.text(this._model._totalSuffix);
        this._discountEl.html(this._model._discount);
        if(this._model.isShowDiscountDetails) {
          this._discountDetailsEl.show();
        }else {
          this._discountDetailsEl.hide();
        }
        // 优惠明细按钮显隐 deliveryPriceInfo这个字段有值才显示优惠明细按钮
        if (this?._model?.deliveryPriceInfo?.preferentialPrice) {
            $('#discountDetailsButton').show();
        } else {
            $('#discountDetailsButton').hide();
        }
        // 1: 领券结算 0: 结算
        if(this._model.deliveryPriceInfo?.checkoutButtonType === 1) {
          this._checkoutBtnText.text('领券结算')
        }else {
          this._checkoutBtnText.text('结算')
        }

        this._totalCheckedCount.text(this._model._totalCheckedCount);
        if(_engine._editStatus){
            this._completeBoxEl.addClass("is-not-edit").removeClass("isedit");  
            this._completeButtonEl.addClass("isedit").removeClass("is-not-edit");    
            this._editBoxEl.addClass("isedit").removeClass("is-not-edit");
            this._editButtonEl.addClass("is-not-edit").removeClass("isedit");        
        }else{
            this._completeBoxEl.addClass("isedit").removeClass("is-not-edit");  
            this._completeButtonEl.addClass("is-not-edit").removeClass("isedit");   
            this._editBoxEl.addClass("is-not-edit").removeClass("isedit"); 
            this._editButtonEl.addClass("isedit").removeClass("is-not-edit"); 
        }

        if(window._shopId != 1){
            $(".header_right span.message").hide();
        }
        

        // this.navTop();
        this.interceptList();
        if(this._model.checkedAll){ // 全选
            this._checkEl.addClass("icon-checked");
        }

        this.regEvent();

        this.checkLogin();
        this.checkCartEmpty();
    }

    regEvent(){
        let that = this;
        $("div.cart_settlement").off("click","div.action").on("click","div.action",function(){
            Bridge.toggleDiscountPopup(false)
            //编辑状态
            if(_engine._editStatus){  
                let _isAllChecked = that._model._isChecked;
                //编辑状态点击权限按钮先清空不可购买商品的选中数据再遍历重新加入
                _engine._editSelectedDisablePurchaseGoods = [];
                _engine._editSelectedDisablePurchaseGoodsNum = 0;
                _engine._group.forEach(x=>{
                    if(x._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE && x._purchaseEnable == false  && x._invalid == false){
                        x._isChecked_fake = !_isAllChecked;
                        if(!_isAllChecked){
                            // wap编辑状态下记录选中的不可购买商品 添加                            
                            _engine._editSelectedDisablePurchaseGoods.push(x._itemId);
                            _engine._editSelectedDisablePurchaseGoodsNum += x._groupCount;
                        }
                    }else{
                        x._mainSkus.forEach(sku=>{
                            if(sku._purchaseEnable == false && x._invalid == false){
                                sku._isChecked_fake = !_isAllChecked;   
                                if(!_isAllChecked){
                                    // wap编辑状态下记录选中的不可购买商品 添加
                                    _engine._editSelectedDisablePurchaseGoods.push(sku._itemId);
                                    _engine._editSelectedDisablePurchaseGoodsNum += sku._count;
                                }
                            }                         
                        })
                    }
                })   

                that._model.batchSetActive().then().catch(err=>{
                    Alert.showTip(err);
                })                           
            }else{                
                that._model.batchSetActive().then().catch(err=>{
                    Alert.showTip(err);
                })
            }
        })
    
        $("button.settlement").off("click").on("click",function(){
            // $("button.settlement").attr("disabled","disabled");
            if(that._model._totalCheckedCount <= 0){
                Alert.showTip(Constant.MSG.NOCHECKED);
                $("button.settlement").attr("disabled",null);
                return;
            }
            
            $util.doLoginAction().then(()=>{
                API.goCheckout({terminal:_terminal}).then(x=>{                    
                    window.location.href = $util.getCheckoutUrl();
                }).catch(err=>{
                    // Alert.showTip(err.msg);
                    //21063显示购买其他商品  否则只显示返回修改
                    if(err.code == "21063"){
                        Alert.showConfirm({
                            title:err.msg,
                            confirmText:"购买其他商品",
                            confirm:function(){
                                API.goCheckout({terminal:_terminal,buyOther:true}).then(x=>{
                                    window.location.href = $util.getCheckoutUrl(true);
                                }).catch(err=>{                                   
                                    Alert.showMessage("warning",err.msg);
                                    $("#gocheckout").attr("disabled",null); 
                                })
                            },
                            cancelText:"返回修改",
                            cancel:function(){
                                
                            }
                        })
                    } else if(err.code == "40051"){// 候补销售需要实名认证，跳转商详页
                        // 请进行实名认证+URL_START+href+URL_END => 请进行实名认证URL_STARThttps://baiud.comURL_END
                        const [msgTitle, startRight] =  err?.msg?.split('URL_START');
                        const href = startRight?.split('URL_END')[0];

                        Alert.showConfirm({
                            title: msgTitle,
                            confirmText: "去认证",
                            confirm: function(){ // 需要实名认证跳转到商详页
                                let toAuthUrl = '';
                                if($util.isProductionEnv()) {
                                    toAuthUrl = `https://mactivity.lenovo.com.cn/consumption_coupon/authentication.html?ru=${encodeURIComponent(href)}`;
                                } else {
                                    toAuthUrl = `https://mactivity.lenovouat.com/consumption_coupon/authentication.html?ru=${encodeURIComponent(href)}`;
                                };
                                window.location.href = toAuthUrl;
                            },
                            cancelText:"暂不认证"
                        })
                    } else{
                        Alert.showTip(err.msg);
                    }
                    $("button.settlement").attr("disabled",null);
                })
            }).catch(err=>{
                Alert.showTip(err.msg);
            })
        })

        $(".le_button_gohome").off("click").on("click",function(){
            if (window?.apputils?.isHarmonyOS) {
                window?.apputils?.toAppNativePage(`lenovoclub://com.lenovo.app/lenovoHome`);
            }else{
                window.location.href = $util.getHomeUrl();
            }
        })

        $(".le_button_login").off("click").on("click",function(){
            window.location.href = $util.getLoginUrl(window.location.href);
        })

        // 编辑按钮
        $("div.header_right span.edit").off("click").on("click",function(){            
            _engine._editStatus = true;
            //编辑状态判断是否全选，接口返回的选中的总数+不可购买商品的选中总数 == 购物车总数-失效商品数
            if(that._model._totalCheckedCount != 0  && (that._model._totalCheckedCount + _engine._editSelectedDisablePurchaseGoodsNum == that._model._totalCount - that._model._invalidNum) ){
                that._model._isChecked = true;
            }else{
                that._model._isChecked = false;
            }
            that.render();
            _engine._group.forEach(g => {
                if(g._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE && g._invalid == false && g._purchaseEnable == false){
                    g._isChecked_fake = g._isChecked;
                }else{
                    g._mainSkus.forEach(m => {
                        if(m._invalid == false && m._purchaseEnable == false){
                            m._isChecked_fake = m._isChecked;
                        }
                    });  
                }              
            });
        })

        // 完成按钮
        $("div.header_right span.complete").off("click").on("click",function(){            
            _engine._editStatus = false;
            // wap编辑状态下记录选中的不可购买商品,完成编辑的时候清空
            _engine._editSelectedDisablePurchaseGoods = [];
            _engine._editSelectedDisablePurchaseGoodsNum = 0 ;
            if(that._model._totalCheckedCount == that._model._purchaseEnableNum && that._model._totalCheckedCount != 0){
                that._model._isChecked = true;
            }else{
                that._model._isChecked = false;
            }
        })

        // 消息按钮
        $("div.header_right i.icon-message").off("click").on("click",function(){
            window.location.href = $util.getMyMessagetUrl();
        })

        
        $("#deleteAllbtn").off("click").on("click",function(){
            let checkedItems = $util.getAllFakeCheckedItems(that._model._parent._group, true);
            if(checkedItems.length == 0){
                Alert.showTip(Constant.MSG.CANNOT_BATCHR_REMOVE);
                return;
            }             
            Alert.showConfirm({
                title:`确定要删除这${checkedItems.length}件商品吗？`,
                confirmText:"确定",
                confirm:function(){
                    that._model.batchRemove(checkedItems).then(()=>{
                        that.checkCartEmpty();
                    }).catch(err=>{
                        Alert.showTip(err.msg);
                    })
                },
                cancelText:"取消",
                cancel:function(){}
            })           
        })

        $("#movetofavbtn").off("click").on("click",function(){
            let checkedItems = $util.getAllFakeCheckedItemsNotPackcage(_engine._group, true);

            if(checkedItems.length == 0){
                Alert.showTip(Constant.MSG.CANNOT_BATCHR_ADD_FAV);
                return;
            }

            Alert.showConfirm({
                title:`确认要将这${checkedItems.length}件商品移入收藏夹吗？`,
                confirmText:"确定",
                confirm:function(){
                    that._model.batchToFavorite(checkedItems).then(()=>{
                        that.checkCartEmpty();
                        let packageItems = $util.getAllFakeCheckedPackageItems(that._model._parent._group);
                        if(packageItems.length > 0){
                            Alert.showTip(Constant.MSG.PACKAGE_NO_ADD_FAV);
                        }
                    }).catch(err=>{
                        Alert.showTip(err);
                    })
                },
                cancelText:"取消",
                cancel:function(){}
            })           
        })

        //删除失效商品
        $("#deletefailurebtn").off("click").on("click",function(){
            let invalidItems = $util.getInvalidItems(that._model._parent._group);
            if(invalidItems.length == 0){
                Alert.showTip(Constant.MSG.NO_INVALID_GOODS);
                return;
            }
            Alert.showConfirm({
                type:"warning",
                title:Constant.MSG.CONFIRM_REMOVE_INVALID_GOODS,
                confirmText:"确定",
                confirm:function(){
                    that._model.batchRemove(invalidItems, true).then(()=>{
                        that.checkCartEmpty();                        
                    }).catch(err=>{
                        Alert.showTip(err);
                    })
                },
                cancelText:"取消",
                cancel:function(){}
            })
        })

        $('#discountDetailsButton').off('click').on('click',function() {
          Bridge.toggleDiscountPopup()
        })
    }
}